import { createContext, useContext, useCallback, ReactNode } from "react";

interface AnalyticsContextValue {
  track: (event: string, properties?: Record<string, unknown>) => void;
}

const AnalyticsContext = createContext<AnalyticsContextValue>({
  track: () => {},
});

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  const track = useCallback((event: string, properties?: Record<string, unknown>) => {
    // Swap this for Segment / PostHog / Mixpanel at integration time
    console.log("[analytics]", event, properties ?? {});
    // window.analytics?.track(event, properties);
  }, []);

  return <AnalyticsContext.Provider value={{ track }}>{children}</AnalyticsContext.Provider>;
}

export function useAnalytics() {
  return useContext(AnalyticsContext);
}
